var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_2619_44088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_2619_44088)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6711 32.0777C35.337 28.8881 32.1551 26.5095 32.1551 23.4821C32.1551 21.4278 33.4717 19.9681 35.9405 19.9681C37.8403 19.9681 39.4475 20.7824 40.4393 22.6675C41.5027 24.6885 42.9418 26.7041 45.0409 27.6037C46.0669 28.0434 46.9073 27.8086 47.5147 27.4286C48.3593 26.9001 48.5176 25.7878 48.1694 24.8543C46.0428 19.1533 40.2831 18.4004 35.6662 18.4004C29.4668 18.4004 24.8035 21.2115 24.8035 25.8067C24.8035 30.1856 29.2474 33.3211 34.569 37.3756C40.9878 42.2951 42.4142 44.4576 42.4142 46.4578C42.4142 49.1068 39.9454 51.0529 36.3794 51.0529C28.4793 51.0529 19.9208 41.6464 18.6042 31.2668H9.49707C10.8686 43.7548 22.7737 52.6748 35.7211 52.6748C44.2247 52.6748 50.7532 49.2689 50.7532 44.0251C50.7532 39.1056 44.883 35.916 39.6711 32.0777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63684 31.2085C12.8457 30.5858 19.6714 29.2611 24.6487 32.5634C26.0563 33.4973 27.7619 34.7524 29.5543 36.0714C35.8387 40.6959 43.1905 46.1059 42.5087 41.2118C42.4994 41.1457 42.4887 41.078 42.4766 41.0086C42.4053 40.5986 42.4004 40.1223 42.4789 39.7996C42.4886 39.7598 42.4996 39.7222 42.5118 39.6875C42.6651 39.2534 43.0221 39.2496 43.6455 40.4832C43.6456 40.4835 43.6456 40.4838 43.6457 40.484C47.8774 48.8584 36.5005 54.0834 30.6113 51.1158C27.9399 49.7696 24.445 45.5837 20.9497 41.3973C16.5986 36.1861 12.247 30.9742 9.48291 31.2387C9.48412 31.2385 9.48532 31.2383 9.48653 31.238C9.48536 31.2381 9.48418 31.2382 9.48301 31.2384C9.53331 31.2286 9.58459 31.2187 9.63684 31.2085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0582 28.6922C47.7707 28.2481 47.1989 26.8214 46.9489 26.1636C46.3832 26.61 44.8712 26.8848 45.0497 27.5333C45.2728 28.3438 46.9983 29.8378 47.6806 30.3221C48.3628 30.8064 49.4956 30.9124 49.4399 30.7098C49.3841 30.5071 48.4175 29.2472 48.0582 28.6922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6572 37.3604C17.7276 33.5254 11.5922 31.6491 9.4873 31.2949C10.2133 37.2837 12.9546 41.9173 16.7216 45.3494C20.5243 48.8141 25.3647 51.7256 32.9812 52.6777C30.384 51.2719 23.5955 46.7441 22.6572 45.3494C24.5845 45.7044 31.2995 47.4102 30.7597 46.3306C29.8668 44.5447 21.9925 44.2082 19.9184 38.8829C21.409 39.3113 28.8193 42.1542 22.6572 37.3604Z",
    fill: "url(#paint1_linear_2619_44088)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.3,
    cy: 12.8,
    r: 12.8,
    fill: "#E33A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 8.44336V17.1545",
    stroke: "white",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6553 12.7988L8.94416 12.7988",
    stroke: "white",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_2619_44088",
    x: -25.1,
    y: -25.6,
    width: 115.2,
    height: 115.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2619_44088"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2619_44088",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.4,
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.429167 0 0 0 0 0.40592 0 0 0 0 0.40592 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2619_44088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2619_44088",
    x1: 32.5,
    y1: 0,
    x2: 32.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323",
    stopOpacity: 0.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2619_44088",
    x1: 19.4627,
    y1: 31.2949,
    x2: 19.4627,
    y2: 51.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAvatar);
export default __webpack_public_path__ + "static/media/add-avatar.71ec30e3837592818095f85d960ff45b.svg";
export { ForwardRef as ReactComponent };